// @ts-ignore
import { getCookieValue } from 'common/js/utils/cookie';
import { logMessage } from './debug';
import { SESSION_COOKIE_NAME } from '../constants';

let isRefreshing = false;

/**
 * Performs the actual session refresh fetch.
 */
async function refreshSession(): Promise<void> {
    if (isRefreshing) {
        logMessage('[session-checker] Refresh already in progress, skipping');
        return;
    }

    isRefreshing = true;
    logMessage('[session-checker] Starting session refresh...');

    try {
        const response = await fetch(window.location.href, {
            method: 'GET',
            cache: 'no-store',
            credentials: 'include',
            headers: { 'session-refresh': 'true' },
        });

        if (!response.ok) {
            logMessage(`[session-checker] Session refresh failed with status: ${response.status}`);
        }
    } catch (error) {
        logMessage('[session-checker] Session refresh error:', error);
    } finally {
        isRefreshing = false;
    }
}

/**
 * Handles visibility change events (tab focus).
 * Only checks cookie presence and refreshes if missing.
 */
function handleVisibilityChange(): void {
    if (document.visibilityState === 'visible' && !getCookieValue(SESSION_COOKIE_NAME)) {
        refreshSession();
    }
}

export function initSessionChecker(): void {
    if (!getCookieValue(SESSION_COOKIE_NAME)) {
        logMessage('[session-checker] Cookie missing on page load, refreshing...');
        refreshSession();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
}
